document.addEventListener("DOMContentLoaded", function(){
    var swiper = new Swiper(".wellnessSwiper", {
        slidesPerView: 3,
        spaceBetween: 20,
        pagination: { el: ".swiper-pagination", clickable: true },
        breakpoints: {
            0: { slidesPerView: 2 },
            768: { slidesPerView: 2 },
            1024: { slidesPerView: 3 }
        }
    });
});